import bezier from 'bezier-easing'

export default bezier(0, 0, 0.58, 1)
